import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<header>

		<nav>


{/* <Link activeClassName={style.active} href="/">Home</Link>  &nbsp;&nbsp; */}

<a target="_blank" href="https://just.is"><div class="button_is">reserve <b>just.is</b> username</div></a> 


</nav>


	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js